import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spacer, Stack, Typography } from '@emburse/embark-core';
import { $t } from '../../../../hooks/useTranslation';
export default function NoExceptionDetails() {
    return (_jsxs(Stack, { spacing: 3, sx: { width: '100%' }, children: [_jsx(Spacer, { size: 2, sx: { width: '100%', backgroundColor: '#eee' } }), _jsx(Typography, { color: "textSecondary", variant: "subtitle2", children: $t('There are no active exceptions for this audit definition') }), _jsx(Spacer, { size: 2 })] }));
}
